import { defineComponent as _defineComponent } from 'vue'
import { Activity } from '@/types/activity'
import { truncatedDates } from '@/utils/date-utils'
import { thumbnailImage } from '@/utils/utility-manager'

interface ActivityTravelPlanListItemProps {
  activity: Activity
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ActivityTravelPlanListItem',
  props: {
    activity: null
  },
  setup(__props: any) {



return { __sfc: true,truncatedDates, thumbnailImage }
}

})